import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { observer, useAsObservableSource } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import {
    CampaignName,
    CampaignNameValue,
    ContentContainer,
    TrashIconWrapper,
    ActiveLabel,
    ImageContainer,
    ImageWrapper,
    ImageTitleWrapper,
} from './QuickLinkTrayListItem.styles';
import { Checkbox } from 'src/components/Checkbox/Checkbox';
import { QuickLinkTrayModelType } from 'src/api/config/quick_link_tray/getQuickLinkTray';
import { ListItem, ActionsWrapper, ButtonsWrapper } from 'src/domains/layouts/shared/cms/list/List.style';
import { MoveUpDown } from 'src/domains/layouts/shared/moreActions/MoveUpDown';
import { Button } from 'src/domains/layouts/shared/buttons/Button';
import { QuickLinkTrayListItemState } from './QuickLinkTrayListItem.state';
export interface QuickLinkTrayPropsType {
    quickLinkTrayItem: QuickLinkTrayModelType;
}

export const QuickLinkTrayListItem = observer((propsInner: QuickLinkTrayPropsType) => {
    const { cmsState } = useAppStateContext();
    const props = useAsObservableSource(propsInner);
    const [state] = React.useState(() => new QuickLinkTrayListItemState(cmsState.quickLinkTrayState, props));
    const { label, is_active, icon, redirect_option } = props.quickLinkTrayItem;

    const { changeActiveFlag, onChangePageToEdit, onRemove } = state;

    return (
        <ListItem
            homepage={false}
            boxHeight='100px'
            data-test='quick-link-item'
            direction='row'
        >
            <ContentContainer>
                <ImageTitleWrapper>
                    <ImageContainer>
                        <ImageWrapper imgSrc={icon} />
                    </ImageContainer>

                    <div>
                        <div>
                            <CampaignName data-test='quick-link-redirection'>Redirect: {redirect_option}</CampaignName>
                        </div>
                        <div>
                            <CampaignName data-test='quick-link-name'>Label: </CampaignName>
                            <CampaignNameValue data-test='quick-link-name-label'>{label}</CampaignNameValue>
                        </div>
                    </div>
                </ImageTitleWrapper>
                <div>
                    <Checkbox
                        labelSide='right'
                        onChange={changeActiveFlag}
                        isChecked={is_active}
                        isDisabled={false}
                        dataTest='quick-link-tray-publish-checkbox'
                    >
                        <ActiveLabel>Active Sport</ActiveLabel>
                    </Checkbox>
                    <ButtonsWrapper>
                        <MoveUpDown
                            moveItemUp={state.moveItemUp}
                            moveItemDown={state.moveItemDown}
                        />
                        <ActionsWrapper>
                            <Button
                                version='secondary'
                                size='small'
                                onClick={onChangePageToEdit}
                            >
                                Edit
                            </Button>
                            <TrashIconWrapper onClick={onRemove} />
                        </ActionsWrapper>
                    </ButtonsWrapper>
                </div>
            </ContentContainer>
        </ListItem>
    );
});
